import Cookies from 'js-cookie';
import axios from 'axios';
import { ElMessage, ElMessageBox } from 'element-plus';
import errReport from '@/lib/errReport';
import { getToken, removeToken } from '@/lib/token';
import { router } from '@/router';
import { getQueryFromUrl } from '@/lib/utils';
import { setStore, getStore } from '@/lib/localStore';

const CancelToken = axios.CancelToken;
// 创建axios实例
const service = axios.create({
  timeout: 60 * 1000, // 请求超时时间
});
const errorHandler = ({ error, report = true }) => {
  const res = error?.response?.data || error;

  if (res?.errcode === 401) {
    ElMessage.error('当前登录已过期，请重新登录');
    needLogin();
    return false;
  } else {
    const msgStr = res?.msg || res?.errmsg || res?.message || res;
    const errData = {
      msg: msgStr,
    };
    const reqData = error?.config?.data || error?.config?.params;
    reqData && Object.assign(errData, { data: reqData });
    if (res?.errcode === 100017 || res?.errcode === 404) {
      ElMessageBox.confirm(msgStr, '登录异常', {
        confirmButtonText: '重新登录',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        needLogin();
      });
      throw error;
    }
    if (msgStr) {
      showErrMsg(msgStr);
      report && errReport(`接口：${error?.config?.url}`, JSON.stringify(errData));
    }
    throw error;
  }
};
const showErrMsg = (msgStr) => {
  ElMessage.error(msgStr);
};
export const needLogin = () => {
  removeToken();
  let parmas = '';
  if (getQueryFromUrl('limitOpt')) {
    parmas = '?limitOpt=' + getQueryFromUrl('limitOpt');
  }
  router.replace('/login' + parmas);
};

// request拦截器
service.interceptors.request.use(
  (config) => {
    config.headers['Access-Characteristic'] =
      getStore({
        name: 'access-characteristic',
      }) || '';
    config.headers['Access-Authentication'] =
      getStore({
        name: 'access-authentication',
      }) || '';
    return config;
  },
  (error) => {
    errorHandler({
      error,
    });
  }
);
// response 拦截器
service.interceptors.response.use(
  (response) => {
    if (response.headers['access-authentication']) {
      setStore({
        name: 'access-authentication',
        content: response.headers['access-authentication'],
      });
    }

    if (response.headers['access-characteristic']) {
      setStore({
        name: 'access-characteristic',
        content: response.headers['access-characteristic'],
      });
    }

    const res = response.data;
    if (res?.code) {
      if ([1, 200].includes(res.code)) {
        return res?.data;
      } else {
        let msgStr = res?.msg || res?.errmsg || res?.message || res?.ElMessage || '抱歉，系统错误';
        return showErrMsg(msgStr);
      }
    } else {
      // 响应体为数据，无code
      return res;
    }
  },
  (error) => {
    if (error.code === 'ERR_CANCELED' || error.message === 'canceled' || error?.response?.status < 500) {
      errorHandler({
        error,
        report: false,
      });
    } else {
      errorHandler({ error });
    }
  }
);

const get = (url, params, options = {}) => {
  return service.get(url, {
    params,
    ...options,
    cancelToken: options.cancelFn ? new CancelToken(options.cancelFn) : undefined,
  });
};
const post = (url, body, headers = {}) => {
  return service.post(url, body, {
    headers,
  });
};
const remove = (url, body) => {
  return service.delete(url, { data: body });
};
const put = (url, body, headers = {}) => {
  return service.put(url, body, {
    headers,
  });
};

export default { get, post, remove, put };
